import { Chip } from '@mui/material'
import {
  disputeStatusColor,
  disputeStatusLabel,
} from '../../core/functions/chargebackDispute'

export default function DisputeStatusChip({
  status,
}: {
  status?: string | null
}) {
  return (
    <Chip
      size="small"
      label={disputeStatusLabel(status)}
      color={disputeStatusColor(status)}
    />
  )
}
